<template>
    <v-btn small outlined color="primary" class="mr-2" v-bind="{ loading }" @click="setOrderStatusPayment">발주확인</v-btn>
</template>

<script>
import api from "@/api";
import { PURCHASE_ORDER_STATUSES } from "@/assets/variables";

export default {
    props: {
        loading: { type: Boolean, default: false },
        selected: { type: Array, default: () => [] },
    },
    methods: {
        async setOrderStatusPayment() {
            if (this.loading) return;
            else this.$emit("loading", true);

            try {
                if (!this.selected.length) throw new Error("발주확인 처리할 구매건을 선택해주세요");

                for (const { _id } of this.selected) {
                    await api.console.shop.purchases.putPurchase({ _id, orderStatus: PURCHASE_ORDER_STATUSES.ORDER_CONFIRM.value });
                }

                alert("발주확인 처리 되었습니다");
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.$emit("loading", false);
                this.$emit("search");
            }
        },
    },
};
</script>

<style></style>
